export const ensureNumbers = <T extends { [k: string]: any }>(payload: T, ...properties: string[]): T => {
  return {
    ...payload,
    ...properties.reduce(
      (acc, property) => {
        const v = Number(payload[property]);
        return {
          ...acc,
          [property]: isNaN(v) || payload[property] === null ? null : v,
        };
      },
      {} as { [k: string]: number | null },
    ),
  };
};
